/**
 * Row-field constants stamped onto every aggregate row (augmentRows in
 * useAggregatedDocuments). Kept in their own dependency-free module so pure logic
 * (e.g. the filter panel's section builder) can import them without dragging in the
 * renderer module's logger/auth import chain. aggregateColumnRenderers re-exports
 * them, so either import path is valid.
 */
export const AGGREGATE_SOURCE_LIST_ID = "__sourceListId";
export const AGGREGATE_SOURCE_LIBRARY_NAME = "__sourceLibraryName";
export const AGGREGATE_SOURCE_WEB_URL = "__sourceWebUrl";
// The name of the site the row's library belongs to (the Site column, shown when client-group
// sites take part).
export const AGGREGATE_SOURCE_SITE_NAME = "__sourceSiteName";
// Cursor identity, NOT the list id: two sources may share a list (two Tess folder
// dossiers in one library), so buffer/cursor lookups must key on this.
export const AGGREGATE_SOURCE_KEY = "__sourceKey";
export const AGGREGATE_ROW_KEY = "__aggregateKey";
export const AGGREGATE_SORT_VALUE = "__aggregateSortValue";
